import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import background from '../assets/homeBg.png'; // Import your background image
import bnb from '../assets/bnb.svg';
import avax from '../assets/avax.svg';
import base from '../assets/base.svg';
import ftm from '../assets/ftm.svg';
import linea from '../assets/linea.svg';
import polygon from '../assets/polygon.svg';
import feature1 from '../assets/feature Image 1.webp';
import feature2 from '../assets/feature Image 2.webp';
import feature3 from '../assets/feature Image 3.webp';
import feature4 from '../assets/feature Image 4.webp';
import countries from '../assets/countries.webp';
// import cashOutImage from '../assets/CashOutLocal.png';
import mobileImage from '../assets/light.png'
import playstoreImage from '../assets/playstore.svg'
import appstoreImage from '../assets/appstore.svg'
import Signup from '../pages/Signup'
import telegram from '../assets/tglogo.png'
import mantaImage from '../assets/manta.png'
// import polo from '../assets/polo.svg'
// import avail from '../assets/AVAIL LOGO.svg'

// import sendReceiveImage from '../assets/sendReceiveImage.webp'
<head><link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&display=swap" rel="stylesheet">
</link>
</head>

const Home = () => {
  const [isPinned, setIsPinned] = useState(false);
  const [offsetX, setOffsetX] = useState(0);
  const fadeInSections = useRef([]);
  const [loaded, setLoaded] = useState(false)
  const featureRef = useRef(null);
  const signupRef = useRef(null);
  const location = useLocation();

  // Function to check the scroll position and update the state
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const threshold = window.innerHeight * 0.8; // Adjusting the threshold for responsiveness

    if (scrollPosition >= threshold) {
      setIsPinned(true); // Pin the h1 at the bottom after scrolling past the threshold
    } else {
      setIsPinned(false); // Keep h1 fixed until reaching the threshold
    }
  };

  // Function to handle cursor movement and adjust h1 position
  const handleMouseMove = (event) => {
    const screenCenterX = window.innerWidth / 2;
    const mouseX = event.clientX;
    const movement = (mouseX - screenCenterX) / 30; // Adjust sensitivity here

    setOffsetX(-movement);
  };

  // Function to observe elements on scroll for fade-in effect
  const observeSections = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    });

    fadeInSections.current.forEach((section) => {
      if (section) observer.observe(section);
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 800);

    if (location.hash === '#feature' && featureRef.current) {
      featureRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if (location.hash === '#signup' && signupRef.current) {
      signupRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    observeSections();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(timer);
    };
  }, [location]);

  return (
    <div >
      {/* Background Section */}

      <div
        className="w-screen h-[104vh] md:h-[112vh] lg:h-[95vh] xl:h-[102vh] flex justify-center items-center mt-[120px] lg:mt-[220px] bg-cover relative"
        style={{ backgroundImage: `url(${background})` }} // Set background image dynamically
      >
{/*
        <img
          src={mobileImage}
          alt=""
          className={`w-[200px] md:w-[260px] mt-[-300px] xl:mt-[-500px] ${loaded ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'} transition-all duration-1000 ease-in-out`}
          style={{ zIndex: 1 }}
        />

*/}
        <h1
          className={`text-homeSm md:text-homeMd xl:text-homeXl roboto-regular tracking-widest text-white transition-transform duration-200 ${isPinned ? 'absolute bottom-0' : 'fixed top-[40%]'
            }`}
          style={{ transform: `translateX(${offsetX}px)`, zIndex: '0' }} // Move h1 horizontally

        >
          <span className="inline-block animate-flipLetter1 font-boldtext-[clamp(3rem,6vw,6rem)] font-semibold tracking-tight leading-[1.05]">D</span>
          <span className="inline-block animate-flipLetter2 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">i</span>
          <span className="inline-block animate-flipLetter3 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">s</span>
          <span className="inline-block animate-flipLetter4 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">c</span>
          <span className="inline-block animate-flipLetter4 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">o</span>
          <span className="inline-block animate-flipLetter4 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">v</span>
          <span className="inline-block animate-flipLetter4 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">e</span>
          <span className="inline-block animate-flipLetter4 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">r</span>
        

          &nbsp;
          <span className="inline-block animate-flipLetter5 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">Z</span>
          <span className="inline-block animate-flipLetter6 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">e</span>
          <span className="inline-block animate-flipLetter7 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">l</span>
          <span className="inline-block animate-flipLetter8 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">F</span>
          <span className="inline-block animate-flipLetter9 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">i</span>

           &nbsp;
          <span className="inline-block animate-flipLetter6 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">L</span>
          <span className="inline-block animate-flipLetter7 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">a</span>
          <span className="inline-block animate-flipLetter8 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">b</span>
          <span className="inline-block animate-flipLetter9 font-boldtext-[clamp(3rem,6vw,6rem)] 
               font-semibold 
               tracking-tight 
               leading-[1.05]">s</span>
        </h1>
        
      </div>

      {/* <div className='h-[10vh]' ref={featureRef} id="feature"></div> */}
      {/* Additional Content */}

      {/* ///////////////////////////Feature Section */}

      <div ref={featureRef} id="feature">
      
        <div className="text-center fade-section opacity-0 transition-opacity duration-1000 mt-5" ref={el => fadeInSections.current[0] = el}>
        <div className="flex justify-center">
 <p className="mt-8 text-sm md:text-base uppercase tracking-[0.25em] text-white/60 text-center"> Web3 Advisory · Growth Marketing · Venture Firm</p>

</div>


          {/* <p style={{ color: '#A8A8A8' }} className="tracking-widest px-4 md:px-20 lg:px-40">
            -
          </p> */}
          
        </div>

     {/*  <div className="flex flex-col md:flex-row justify-center pt-20 pb-10 items-center fade-section opacity-0 transition-opacity duration-1000" ref={el => fadeInSections.current[1] = el}>
          {/* <a href="#" ><img src={appstoreImage} className='p-2 w-[180px] md:w-60 ' alt="appstore Image" /></a>
          <a href="#"><img src={playstoreImage} className='p-2 w-[180px] md:w-60' alt="Playstore Image" /></a>
          <a href="https://calendly.com/hussainzulfiqar142"><img src={telegram} img className='p-2 w-[180px] md:w-60' alt="Playstore Image" /></a>
        </div> */} 

        
        <div className="flex flex-col-reverse md:flex-row font-sans p-3 text-center md:text-left mt-10 items-center fade-section opacity-0 transition-opacity duration-1000 rounded-none md:rounded-xl" ref={el => fadeInSections.current[9] = el}>

          <div className='p-2 lg:p-20 w-[100%] lg:w-[70%]'>
            <h1 className='text-lg xl:text-l font-playfair italic '> We empower top crypto projects through deep expertise and a global network of industry leaders.</h1>
            <br></br>
<br></br>
            <h1 className='text-lg xl:text-l font-playfair italic'>  Our support spans Blockchain Infrastructure, AI, DeFi, Layer 1s, Gaming, RWAs, and beyond helping projects scale and thrive. 30+ startups supported, contributing to $100M+ raised and reaching millions of users.</h1>
            
            
            

          </div>
          {/* Second div with the image (this will be rendered first on small screens) */}
          <div className='m-auto mt-5 lg:mt-auto w-[100%] lg:w-[30%]'>
            <img src={mantaImage} alt="network" />
          </div>

          {/* First div with text content (this will be rendered second on small screens) */}


        </div>





        {/* Scrollable chains section */}
        <div className="text-center overflow-hidden mt-40 bg-bgFeature py-20 fade-section opacity-0 transition-opacity duration-1000" ref={el => fadeInSections.current[6] = el}>
      

          {/* Scrollable div on smaller screens */}
          <div className="flex justify-center mt-0.5 space-x-3 md:space-x-10">
            <img src={polygon} className="w-40 overflow-hidden rounded-[30%]" alt="Polygon" style={{ borderRadius: '30% !important', background: 'blue' }} />
            <img src={bnb} className="w-40 overflow-hidden rounded-[30%]" alt="BNB" />
            <img src={ftm} className="w-40 overflow-hidden rounded-[30%]" alt="FTM" />
            <img src={avax} className="w-40 overflow-hidden rounded-[30%]" alt="AVAX" />
            <img src={linea} className="w-40 overflow-hidden rounded-[30%]" alt="Linea" />
            <img src={base} className="hidden md:block w-40 overflow-hidden rounded-[30%]" alt="Base" />
          </div>
        </div>

        

        {/* Cashout and Send Money sections */}
        {/* <div className="flex flex-wrap md:flex-nowrap md:flex-row-reverse p-10 text-center md:text-left bg-bgFeature mt-10 items-center w-[100%] xl:w-[80%] m-auto fade-section opacity-0 transition-opacity duration-1000 rounded-none md:rounded-xl" ref={el => fadeInSections.current[7] = el}>



          
          <div className='p-2 xl:p-10'>
            <p className='text-lg' style={{ color: '#6f50ff' }}>Send Money at Lightning Speed!*</p>
            <h1 className='text-lg font-bold roboto-regular mt-5'>
              <b>ZelFi offers ultra-fast multi-currency off-ramps worldwide, focusing on highly adopted Asian and emerging markets, even where major players fall short.</b>
            </h1>
          </div>

          
          <div className='m-auto mt-5 lg:ml-20'>
            <img src={cashOutImage} alt="Cashout" className='w-[700px]' />
          </div>

        </div> */}




        {/* countries */}

    
      

        {/* signup */}

        <div className='h-[1vh] md:h-[2vh]' ref={signupRef} id="signup"></div>

        <div className='w-[100%] lg:w-[80%] m-auto mt-20 rounded-none md:rounded-xl overflow-hidden' ref={signupRef} id="signup">
          <Signup />
        </div>
      </div>
    </div>
  );
};

export default Home;





{/* <a
            href="#"
            className=" ml-2 w-[170px] md:w-60 mt-2 flex  justify-start p-[1.5px] rounded-lg"
            style={{
              background: 'linear-gradient(to right, #b9e1f0 , #b9e1f0, #877967)',

              borderRadius: '7px',
            }}
          >
            <div
              className="w-full h-full flex items-center"
              style={{
                backgroundColor: 'rgba(22,27,34,255)', // Inner background color
                borderRadius: '5px', // Match inner border radius
              }}
            >
              <img src={telegram} className="pl-2 py-1 h-[40px] md:h-[50px]" alt="" />
              <button className="leading-none pl-2">
                Download in
                <br />
                <span className="sm:font-bold text-[20px]">Telegram</span>
              </button>
            </div>
          </a> */}





{/* <div className="flex flex-wrap justify-between md:flex-nowrap p-10 text-center md:text-left bg-gray-300 mt-10 items-center w-[100%] m-auto fade-section opacity-0 transition-opacity duration-1000" style={{ borderRadius: '20px' }} ref={el => fadeInSections.current[8] = el}>
          <div className='p-2 xl:p-20'>
            <h1 className='text-xl md:text-xxl font-bold roboto-regular mt-5'><b>Send and Receive Money From Anywhere </b></h1>
            <p className='text-lg  text-gray-100'>USD account for remote workers</p>
            <div className='mt-5'>
              <p className="text-md mt-2" style={{ fontSize: '17px' }}>Send money in minutes with the best exchange rate</p>
              <p className="text-md mt-2 text-gray-100" style={{ fontSize: '17px' }}>Earn up to 6.74% interest on your USD Balance</p>
              <p className="text-md mt-2" style={{ fontSize: '17px' }}>Get a dedicated USD virtual bank account and add USDC seamlessly to your wallet</p>
              <p className="text-md mt-2 text-gray-100" style={{ fontSize: '17px' }}>Never lose access to your money with our self-custody wallets</p>
            </div>

            <div>
              <button className='m-3 ml-0 font-bold w-[200px] h-[50px] p-3' style={{ background: '#6f50ff', borderRadius: '10px' }} >Download App</button>
              <button className='m-3 ml-0 xl:ml-3  font-bold  w-[200px] h-[50px] p-3' style={{ background: 'white', color: 'black', borderRadius: '10px' }} >Join Community</button>
            </div>

          </div>
          <div className='m-auto mt-5'>
            <img src={sendReceiveImage} alt="Cashout" className='w-[100%]' />
          </div>
        </div> */}